import { useMutation, useQueryClient } from '@tanstack/react-query';
import { mainCategoryServices } from '../services/main-category.service';
import toast from 'react-hot-toast';

export const useAddMainCategory = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => mainCategoryServices.addMainCategory(payload),
    onSuccess: () => {
      queryClient.invalidateQueries(['main-category']);
      //   toast.success('Admin created successfully');
    },
    onError: (error) => {
      toast.error(error?.response?.data?.message || 'Failed to add main category');
    },
  });
};
